import { type PropsWithChildren } from 'react';
import { SessionContext, type SessionContextValue } from './SessionContext';

export function SessionProvider({
  value,
  children,
}: PropsWithChildren<{ value: SessionContextValue }>) {
  return <SessionContext.Provider value={value}>{children}</SessionContext.Provider>;
}
